export { default } from './SpotSatelliteWithPin';
